<script>
import VuePannellum from "vue-pannellum";

export default {
  name: "gallery360",

  components: {
    VuePannellum,
  },

  data() {
    return {
      pannellumConfig: {
        default: {
          firstScene: "Pic 2",
          author: "",
        },

        scenes: {
          "Pic 1": {
            //1
            title: "Pic 1",
            hfov: 100,
            yaw: 0,
            type: "equirectangular",
            panorama: "./images/360/R0010634_20210222180801.JPG",
            hotSpots: [
              {
                pitch: -3,
                yaw: 342,
                type: "info",
                text: "Adrienne Green",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "a533feff");
                },
              },
              {
                pitch: -3,
                yaw: 0,
                type: "info",
                text: "Gregory Perrier",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "da525135");
                },
              },
              {
                pitch: -3,
                yaw: 23,
                type: "info",
                text: "Lorie-Mae Nicolas",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "e6f65c07");
                },
              },
              {
                pitch: -3,
                yaw: 43,
                type: "info",
                text: "Holly Chery",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "6cb8dcb7");
                },
              },
              {
                pitch: -4,
                yaw: 183,
                type: "info",
                text: "Ja&rsquo;Neil G. Humphrey",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "228100cd");
                },
              },
              {
                pitch: -4,
                yaw: 155,
                type: "info",
                text: "Danae Smart",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "ebbcb0e9");
                },
              },
              {
                pitch: -7,
                yaw: 137,
                type: "info",
                text: "Va Shon Williams",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "b866ba69");
                },
              },
              {
                pitch: -25,
                yaw: 280,
                type: "scene",
                text: "Next",
                sceneId: "Pic 2",
              },
            ],
          },

          "Pic 2": {
            //1
            title: "Pic 2",
            hfov: 100,
            yaw: 0,
            type: "equirectangular",
            panorama: "./images/360/R0010642_20210222181248.JPG",
            hotSpots: [
              {
                pitch: -5,
                yaw: 347,
                type: "info",
                text: "Genise Browne",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "5778ac37");
                },
              },
              {
                pitch: -5,
                yaw: 2,
                type: "info",
                text: "Mykal Quinlan",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "0c16d7a7");
                },
              },
              {
                pitch: -3,
                yaw: 17,
                type: "info",
                text: "Simone DeShields",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "e39bbefb");
                },
              },
              {
                pitch: -5,
                yaw: 52,
                type: "info",
                text: "Alanna James",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "291c838d");
                },
              },
              {
                pitch: -3,
                yaw: 62,
                type: "info",
                text: "Izuchi Ukegbu",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "a5cd1fed");
                },
              },
              {
                pitch: -3,
                yaw: 83,
                type: "info",
                text: "Kimberly Reid",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "e37f6671");
                },
              },
              {
                pitch: -3,
                yaw: 105,
                type: "info",
                text: "Shaunrick Stoll",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "ec74d810");
                },
              },
              {
                pitch: -3,
                yaw: 122,
                type: "info",
                text: "Aurriel Fenison",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "7d53a447");
                },
              },
              {
                pitch: -5,
                yaw: 132,
                type: "info",
                text: "Ashlea Hendrickson",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "687d974b");
                },
              },
              {
                pitch: -5,
                yaw: 141,
                type: "info",
                text: "Ashley Saunders",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "4783bf9a");
                },
              },
              {
                pitch: -6,
                yaw: 151,
                type: "info",
                text: "Shevel Dacosta-Davis",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "92904634");
                },
              },
              {
                pitch: -3,
                yaw: 165,
                type: "info",
                text: "Yamiko Jessica Chanza",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "d1b567c8");
                },
              },
              {
                pitch: -6,
                yaw: 181,
                type: "info",
                text: "Kristoff Foster",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "cb0bb7c7");
                },
              },
              {
                pitch: -4,
                yaw: 199,
                type: "info",
                text: "Joseph Smittick",
                clickHandlerFunc: () => {
                  this.$emit("show:itemid", "5fa3fe10");
                },
              },
              {
                pitch: -25,
                yaw: 280,
                type: "scene",
                text: "Next",
                sceneId: "Pic 1",
              },
            ],
          },
        },
      },
    };
  },
};
</script>

<template>
  <VuePannellum class="my-3" :src="pannellumConfig" style="height: 500px" />
</template>

<style lang="scss">
.pnlm-container {
  font-family: "DM Serif Display", serif !important;
}
</style>